<template>
  <v-container style="min-height: calc(100vh - 80px);">
    <v-row>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="paramberita.type"
          :items="listcategory"
          label="Category"
          name="category">
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          prepend-inner-icon="search"
          v-model="paramberita.keyword"
          label="News title, keyword"
          name="keyword">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          class="mt-1 white--text"
          type="submit"
          large
          :color="maincolor"
          block
          @click="getBeritaFilter">
          <v-icon left>search</v-icon> Search
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="datalist.length > 0">
      <v-col
        class="d-flex" style="flex-direction:column"
        cols="12"
        md="4"
        v-for="(news, i) in datalist"
        :key="i">
        <v-card
          class="flex-grow-1"
          rounded="lg"
          outlined
          :style="'border-color: ' + maincolor">
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="py-0">
                <v-img
                  v-if="news.pic_berita"
                  :lazy-src="require('../assets/default.jpg')"
                  :src="api + '/upload/news/' + news.pic_berita">
                </v-img>
                <v-img
                  v-if="!news.pic_berita"
                  :lazy-src="require('../assets/default.jpg')"
                  :src="require('../assets/default.jpg')">
                </v-img>
              </v-col>
              <v-col cols="12" md="12">
                <h1 class="title font-weight-bold">
                  <router-link class="text-decoration-none"
                    :to="{ name: 'NewsDetail', query: { berita: news.id_berita } }">
                    {{ news.judul_berita }}
                  </router-link>
                </h1>
                <div class="d-flex">
                  <v-chip
                    class="mr-1 my-2 d-inline"
                    small
                    dark>
                    <v-icon left small>
                      mdi-calendar-range
                    </v-icon>
                    {{ news.tgl_berita }} {{ news.type_berita === 'event' ? ' ~ ' + news.tgl_end : '' }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <ShareNetwork
                    network="facebook"
                    :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                    :title="news.judul_berita"
                    :description="news.prev_berita"
                    :quote="news.prev_berita"
                    hashtags="careercenter,pnb,bali"
                    class="text-decoration-none d-inline mr-1 my-2">
                    <v-icon color="indigo">
                      mdi-facebook
                    </v-icon>
                  </ShareNetwork>
                  <ShareNetwork
                    network="whatsapp"
                    :url="getRouteUrl('NewsDetail', { berita: news.id_berita })"
                    :title="news.judul_berita"
                    :description="news.prev_berita"
                    :quote="news.prev_berita"
                    hashtags="careercenter,pnb,bali"
                    class="text-decoration-none d-inline mr-1 my-2">
                    <v-icon color="green">
                      mdi-whatsapp
                    </v-icon>
                  </ShareNetwork>
                </div>
                <div
                  class="content-editor"
                  v-html="news.prev_berita">
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <infinite-loading :identifier="infiniteId" @infinite="getBerita">
          <div slot="spinner">Loading...</div>
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../components/Alert.vue';
import InfiniteLoading from 'vue-infinite-loading';
import { mapState } from 'vuex';

export default {
  name: 'News',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      check: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    baseurl: process.env.VUE_APP_BASEURL,
    publickey: '123',
    datalist: [],
    listcategory: ['berita', 'event'],
    panduan: null,
    paramberita: {
      type: '',
      keyword: '',
      limit: 15,
      offset: 0,
    },
    check: {
      reference: '',
    },
    formcheck: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    infiniteId: +new Date(),
  }),
  mounted() {
    // this.getBerita();
    if (this.$route.query.reference && this.$route.query.reference !== '') {
      this.check.reference = this.$route.query.reference;
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
    ]),
  },
  methods: {
    getRouteUrl(nameroute, paramroute) {
      const props = this.$router.resolve({
        name: nameroute,
        query: paramroute,
      });
      // console.log(props);
      return this.baseurl + '' + props.href;
    },
    getBeritaFilter() {
      this.paramberita.offset = 0;
      this.datalist = [];
      this.infiniteId += 1;
    },
    getBerita($state) {
      this.axios
        .get(
          this.api + '/public/berita',
          {
            params: this.paramberita,
            headers: {
              Authorization: 'bearer ' + this.publickey,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.error === false) {
              if (resdata.data.length > 0) {
                this.paramberita.offset += this.paramberita.limit;
                this.datalist.push(...resdata.data);
                if (this.datalist.length < this.paramberita.offset) {
                  $state.complete();
                } else {
                  $state.loaded();
                }
              } else {
                $state.complete();
              }
            }
          }
          // this.loading.check = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loading.check = false;
        });
    },
  },
  components: {
    Alertsp,
    InfiniteLoading,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
